var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62988 2.75891C2.28988 2.75891 2.00989 3.03891 2.00989 3.37891V4.23889L8.74988 9.76889C9.55988 10.4289 10.7199 10.4289 11.5299 9.76889L18.2599 4.23889V3.37891C18.2599 3.03891 17.9799 2.75891 17.6399 2.75891H2.63989H2.62988ZM2.00989 6.66891V13.3789C2.00989 13.7189 2.28988 14.0089 2.62988 14.0089H17.6299C17.9699 14.0089 18.2499 13.7289 18.2499 13.3789V6.66891L12.6998 11.2189C11.1998 12.4489 9.03992 12.4489 7.53992 11.2189L1.98987 6.66891H2.00989ZM0.129883 3.37891C0.129883 1.99891 1.24988 0.878906 2.62988 0.878906H17.6299C19.0099 0.878906 20.1299 1.99891 20.1299 3.37891V13.3789C20.1299 14.7589 19.0099 15.8789 17.6299 15.8789H2.62988C1.24988 15.8789 0.129883 14.7589 0.129883 13.3789V3.37891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailW);
export default __webpack_public_path__ + "static/media/mail_w.ea7d15d913d76703eb6f0fbfe52576d0.svg";
export { ForwardRef as ReactComponent };